import styled from "styled-components";

export const ContentLinkSettingsDropdown = styled.div`
    min-width: 150px;
`;

export const ContentRightSideDesktopPanel = styled.div`
    display: flex;
    align-items: center;
`;

export const ContentRightSideDesktopEditWrapper = styled.div`
    padding: 0 15px;
`;

export const ContentRightSideDesktopEditPreviewWrapper = styled.div`
    padding: 0 0 0 5px;
`;